export enum IdNumberCountries {
  ES = "ES",
}
